<mat-tab-group>
  <mat-tab label="Courses">

    <div class="training-component" style="margin-top: 20px; margin-left: 10px;">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">

      </div>
      <div style="display: flex; flex-direction: row; gap: 12px">
        <div style="display: flex; flex-direction: column; flex:0 0 300px; margin-left: 40px;" class="list" *ngIf="expanded">
          <div *ngFor="let quiz of trainings" style="white-space: nowrap; display: flex; flex-direction: row;">
            <a style="display: inline-block;text-overflow: ellipsis;width: 100%;overflow:hidden; flex:0 1 auto"
               [pTooltip]="quiz.quizData.name + (canEdit ?  ' last updated on ' + (quiz.modifiedDate | date : 'shortDate') + ' by ' + quiz.modifiedBy : '')" [routerLink]="['/training', quiz.id]" routerLinkActive="active"
               class="training-link">{{quiz.quizData.name}}<sup
              *ngIf="canEdit">{{quiz.submissions}}</sup></a>
            <i style="display: inline-block; flex:1 1 auto" *ngIf="canEdit" [routerLink]="['/training', 'edit', quiz.id]"
               class="fa fa-edit"></i>
          </div>
          <div style="margin-left: 10px;" *ngIf="canEdit">
            <a [routerLink]="['/training', 'create']">
              <div class="fa fa-plus"></div>
            </a>
          </div>
        </div>
        <div style="flex:0 0 16px" class="toggler" (click)="expanded = !expanded">
          <span style="position: fixed;">{{expanded ? '<' : '>'}}</span>
        </div>

        <div style="width: 100%;">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Users" *ngIf="canEdit">
    <trainingSummary-component></trainingSummary-component>
  </mat-tab>
</mat-tab-group>
